// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition20Circle: FC<Recognition20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M8.097 15.166a6.292 6.292 0 0 0 2.942 1.277l-1.053 1.824-.879-1.134-.175-.226-1.705-.234.87-1.507ZM16.773 16.673l-1.706.234-1.055 1.36-1.052-1.824a6.29 6.29 0 0 0 2.942-1.277l.87 1.507Z" />
            <path
                d="M12 5.276a4.918 4.918 0 1 1-.001 9.836A4.918 4.918 0 0 1 12 5.276Zm-.845 5.729L9.674 9.523l-.994.994 2.475 2.475 4.001-4-.993-.995-3.008 3.008Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm0 3.871a6.324 6.324 0 0 0-6.323 6.323c0 1.495.52 2.867 1.387 3.95l-2.1 3.637 3.209.44 1.985 2.56L12 17.59l1.84 3.19 1.987-2.56 3.208-.44-2.1-3.637A6.323 6.323 0 0 0 12 3.87Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Recognition20Circle;
